/**
 * This module is designed to prevent page transitions when there is unsaved input data.
 * While React Router provides a useBlocker feature, it cannot handle the following cases where history.state.idx becomes null, making it impossible for React Router to determine the previous state:
 * - Direct URL input
 * This module provides functionality to block page transitions in the above cases.
 */

let currentIndex: number | undefined = undefined;

/**
 * This function sets the current index of the history state.
 * It is used to populate the idx value when it is not present.
 * @param index The current index of the history state.
 */
export const setCurrentIndex = (index: number) => {
  currentIndex = index;
};

/**
 * This function sets the idx property in the history state if it is missing
 * due to direct URL input to work useBlocker of React Router.
 */
export const setMissingHistoryIdx = () => {
  if (currentIndex == null) return;
  const currentState = history.state || {};
  if (typeof currentState.idx === "number") return;
  history.replaceState(
    { ...currentState, idx: currentIndex + 1 },
    "",
    location.href,
  );
};

/**
 * This function registers an event handler to prevent page transitions triggered by React Router.
 * To ensure the event is executed before React Router's own handlers,
 * it must be executed before react router registers an event handler.
 */
export const registerPopStateBlocker = () => {
  // Only the popstate event is handled.
  // The following events are not handled:
  // - beforeunload (because it does not fire on hash changes)
  // - hashchange (because it fires after popstate)
  window.addEventListener("popstate", setMissingHistoryIdx);
};
